import React from "react";

function ExportExcelIconSmall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        width="16"
        height="16"
        rx="2"
        fill="#199d58"
      />
      <path
        d="M3 4H13V5H3V4Z"
        fill="#1b7343"
      />
      <path
        d="M3 6H13V7H3V6Z"
        fill="#1b7343"
      />
      <path
        d="M3 8H13V9H3V8Z"
        fill="#1b7343"
      />
      <path
        d="M3 10H13V11H3V10Z"
        fill="#1b7343"
      />
      <path
        d="M3 12H10V13H3V12Z"
        fill="#1b7343"
      />
      <text
        x="11"
        y="13"
        fontSize="7"
        fill="#fff"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        textAnchor="middle"
      >
        X
      </text>
    </svg>
  );
}

export default ExportExcelIconSmall;

